<script>
export default {
  name: 'SingleSpa',
  render (h) {
    return h()
  },
}
</script>
